export enum AppRegion {
  AU = 'AU',
  DE = 'DE',
  SE = 'SE',
  UK = 'UK',
  US = 'US',
  Unknown = 'Unknown',
}
